import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { ButtonBase } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import LineSeparator from "commons/ui/LineSeparator";

import { useBlockGroupContext } from "components/form/Blocks";

import { TitleFunctionTopBlockHookType } from "hooks/useTitleFunctionsTopBlock";

type PropsType = {
    titleFunctionsTopBlockHook: TitleFunctionTopBlockHookType;
};

function TitleFunctionsTopBlock({ titleFunctionsTopBlockHook }: PropsType) {
    const { buttonCloseBlock, onButtonDeleteClick, closedBlock, title } =
        titleFunctionsTopBlockHook;

    const { setSingleBlockFocus, setDraggable } = useBlockGroupContext();

    return (
        <>
            <GridColumn>
                <GridRow justifyContent="space-between">
                    <div>
                        <GridRow alignItems={"center"}>
                            <GridItem>
                                <ButtonBase
                                    onClick={() => {
                                        buttonCloseBlock();
                                        setSingleBlockFocus(!closedBlock)
                                    }}
                                >
                                    <ArrowBackIosNewIcon
                                        className={closedBlock ? "arrow-closed" : "arrow-opened"}
                                    />
                                </ButtonBase>
                            </GridItem>

                            <GridItem>
                                <h2>{title}</h2>
                            </GridItem>
                        </GridRow>
                    </div>

                    <div>
                        <GridRow alignItems={"center"}>
                            <GridItem>
                                <ButtonBase onClick={onButtonDeleteClick}>
                                    <DeleteIcon />
                                </ButtonBase>
                            </GridItem>

                            <GridItem>
                                <ButtonBase
                                    className={"drag-indicator-icon"}
                                    style={{ padding: "0.15rem" }}
                                    onMouseDown={() => setDraggable(true)}
                                >
                                    <DragIndicatorIcon />
                                </ButtonBase>
                            </GridItem>
                        </GridRow>
                    </div>
                </GridRow>
            </GridColumn>

            {closedBlock && <LineSeparator />}
        </>
    );
}

export default TitleFunctionsTopBlock;
